<template>
	<div>
		<button
			class="btn btn-link btn-sm"
			data-toggle="dropdown"
			:disabled="load"
		>
			<i v-if="!load" class="fa fa-ellipsis-v"></i>
			<i v-else class="fa fa-spin fa-spinner"></i>
		</button>
		<ul class="dropdown-menu">
			<li>
				<a @click="$emit('register')">
					<i class="fa fa-plus"></i> Novo registro
				</a>
			</li>
			<li>
				<a @click="$emit('openSettings')">
					<i class="fa fa-gear"></i> Configurações
				</a>
			</li>
			<li>
				<label for="csv">
					<i class="fa fa-download"></i> Importar (.CSV)
				</label>
			</li>
			<li>
				<a class="disabled">
					<i class="fa fa-upload"></i> Exportar (.CSV)
				</a>
			</li>
			<li class="divider"></li>
			<li class="btn-delete">
				<button class="btn btn-danger btn-block" @click="deleteTable">
					<i class="fa fa-trash"></i>
					Excluir tabela
				</button>
			</li>
		</ul>
		<input
			id="csv"
			type="file"
			accept=".csv"
			class="hidden"
			@change="loadCSV"
		/>
	</div>
</template>
<script>
	import toastr from 'toastr';
	import WBS from 'js/http';
	import swal from 'sweetalert';

	export default {
		name: 'ActionMenu',
		props: ['tid', 'inputs'],
		data() {
			return {
				load: false,
				importStatus: [],
				importLength: 0,
			};
		},
		watch: {
			importStatus: function (val) {
				if (val.length == this.importLength) {
					let status = 'success';
					val.forEach((item) => {
						if (item.status != 'success') status = 'error';
					});
					this.load = false;
					if (status == 'success') {
						toastr.success('CSV importado com sucesso!');
						this.$emit('updateTable');
					} else {
						toastr.error(
							'Não foi possível importar a tabela toda ou parcialmente!'
						);
						console.log(val);
					}
				}
			},
		},
		methods: {
			deleteTable() {
				swal({
					title: 'Atenção, ação irreversível...',
					text: 'Esta ação apagará todos os registros dessa tabela e a propria tabela, este ato será irreversível; Só prosiga se você tiver certeza que desejá excluir essa tabela.',
					icon: 'warning',
					buttons: ['Cancelar', 'Apagar'],
					dangerMode: true,
				}).then((v) => {
					if (v) {
						WBS.send(
							'private-delete-smartTables',
							this.tid,
							(resp) => {
								if (
									resp.status == 'success' &&
									resp.data == true
								) {
									toastr.success(
										'Tabela excluída com sucesso!'
									);
									this.$emit('returnBase');
								} else {
									toastr.error('Erro inesperado!');
									console.log(resp);
								}
							}
						);
					}
				});
			},
			validate(l0) {
				let resp = false;
				this.inputs.forEach((item) => {
					let index = l0.findIndex((id) => id == item.id);
					if (index != -1) resp = true;
				});
				return resp;
			},
			import(l0, quers) {
				for (let id in quers) {
					let sData = {
						l0: l0,
						quers: quers[id],
						tid: this.tid,
					};
					WBS.send('private-save-smartTables:import', sData, (resp) =>
						this.importStatus.push(resp)
					);
				}
			},
			loadCSV(e) {
				this.load = true;
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;
				let reader = new FileReader();
				reader.onload = (cvs) => {
					let b64 = window.atob(
						cvs.target.result.replace(
							'data:application/vnd.ms-excel;base64,',
							''
						)
					);
					b64 = b64.split('\n');
					let l0 = b64[0];
					l0 = l0.split(';');
					if (this.validate(l0)) {
						b64.splice(0, 1);
						let resp = {};
						let error = [];
						b64.forEach((item, index) => {
							if (item.split(';').length == l0.length) {
								if (resp[parseInt(index / 50)] == undefined)
									resp[parseInt(index / 50)] = [];
								resp[parseInt(index / 50)].push(
									item.split(';')
								);
								this.importLength = parseInt(index / 50);
							} else {
								if (item[0] != undefined && item[0] != '')
									error.push(item.split(';'));
							}
						});
						if (error.length == 0) this.import(l0, resp);
						else {
							toastr.warning(
								`Foram encontratos ${error.length} Erro(s), não use ";" nas colunas!`
							);
							console.log(error);
						}
					} else {
						toastr.warning(
							'Não exite correspondência entre a Linha 0 e os IDS da tabela; Operação cancelada!'
						);
					}
				};
				reader.readAsDataURL(files[0]);
			},
		},
	};
</script>
<style scoped>
	.dropdown-menu li label {
		color: #444;
		cursor: pointer;
		display: block;
		padding: 3px 20px;
		clear: both;
		font-weight: 400;
		line-height: 1.42857143;
		white-space: nowrap;
	}
	.dropdown-menu li:hover label {
		background-color: #e1e3e9;
		color: #333;
	}
	.btn-delete {
		padding: 0 20px 5px 20px;
	}
	.dropdown-menu li a {
		cursor: pointer;
	}
	.disabled {
		opacity: 0.5;
		background: #fff !important;
		cursor: not-allowed !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/models/tables/components/action-menu.vue